module.exports = __webpack_public_path__ + "static/header-f0f935439ce286f123990d60bc0ff4d1.png";